import { render, staticRenderFns } from "./OrderBoxRecoger.vue?vue&type=template&id=5eca2df9&scoped=true&"
import script from "./OrderBoxRecoger.vue?vue&type=script&lang=js&"
export * from "./OrderBoxRecoger.vue?vue&type=script&lang=js&"
import style0 from "./OrderBoxRecoger.vue?vue&type=style&index=0&id=5eca2df9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eca2df9",
  null
  
)

export default component.exports